@if (isLoggedIn()) {
  <lib-announcement-banner-container [appType]="announcementAppType"></lib-announcement-banner-container>
}

<router-outlet></router-outlet>

<router-outlet name="popup"></router-outlet>

<lib-toasts aria-live="polite" aria-atomic="true"></lib-toasts>
